export default __webpack_public_path__ + "static/media/unit-result-game-win.53ba5c1d.png";